<template>

  <form class="form" @submit.prevent="$emit('registerSubmit')">

    <div class="form__rows">
      <Row type="text" name="mail" :value="register_data.mail" :placeholder="t('mail')" @updateValue="updateValue"/>
      <Row type="text" name="pass" :value="register_data.pass" :placeholder="t('password')" @updateValue="updateValue"/>
      <Row type="text" name="pass_again" :value="register_data.pass_again" :placeholder="t('password_confirm')" @updateValue="updateValue"/>
    </div>

    <div class="form__buttons">
      <div class="button" @click="$emit('emitLogin')">{{ t("back_to_login") }}</div>
      <input type="submit" class="button button--create" :value="t('register')"/>
    </div>

  </form>

</template>

<script>
import Row from "@/Library/Forms/Row.vue";
import View from "@/views/View.vue"

export default {
  name: "AuthRegisterForm",
  components: {
    Row
  },
  emits: ["emitLogin", "registerSubmit"],
  extends: View,
  props: {
    register_data: {
      default() {
        return null
      }
    }
  },
  methods: {
    /**
     * Aktualizowanie wartości przekazywanych przez propsy
     * @param name nazwa
     * @param value wartość
     */
    updateValue(name, value) {
      this.$props["register_data"][name] = value
    }
  }
}
</script>

<style scoped lang="scss">

.form {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  min-height: 100%;

  &__rows {

    & > div {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    & > p:last-child {
      margin-top: 20px;
      text-align: end;
      cursor: pointer;
      color: rgb(73, 78, 155);
    }
  }

  &__buttons {
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    margin-top: auto;
  }
}

.button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 14px 28px;
  border-radius: 0.25rem;
  background-color: rgb(73, 78, 155);
  color: #fff;
  cursor: pointer;
  font-size: 1rem;

  &--create {
    background-color: #42855B;
  }
}

html.contrast {

  & .form {

    &__rows {

      & > p:last-child {
        color: gold;
      }
    }
  }

  & .button {
    background-color: gold;
    color: #000;
  }
}

</style>